import { render, staticRenderFns } from "./RolesList.vue?vue&type=template&id=3d1fa5a2&scoped=true&"
import script from "./RolesList.vue?vue&type=script&lang=js&"
export * from "./RolesList.vue?vue&type=script&lang=js&"
import style0 from "./RolesList.vue?vue&type=style&index=0&id=3d1fa5a2&prod&lang=scss&scoped=true&"
import style1 from "./RolesList.vue?vue&type=style&index=1&id=3d1fa5a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1fa5a2",
  null
  
)

export default component.exports